import { render, staticRenderFns } from "./ProfileAccess.vue?vue&type=template&id=3eb0ed86&"
import script from "./ProfileAccess.vue?vue&type=script&lang=js&"
export * from "./ProfileAccess.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb0ed86')) {
      api.createRecord('3eb0ed86', component.options)
    } else {
      api.reload('3eb0ed86', component.options)
    }
    module.hot.accept("./ProfileAccess.vue?vue&type=template&id=3eb0ed86&", function () {
      api.rerender('3eb0ed86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/ProfileAccess.vue"
export default component.exports